/**
 * 情报COS路径（文档，存广州的COS桶，仅广州的COS桶支持COS文档预览功能）
 */
export const DBI_FILE_COS_PATH = '/intelligence';

/**
 * 情报COS路径（普通图片）
 */
export const DBI_IMG_COS_PATH = '/intelligence-img';
